import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from '../config/api-client';
import { ApiArticle } from '../constants/ApiArticle';
import { ArticleResponse, ArticleDetailResponse, DeleteArticleRequest, AddArticleToProjectRequest } from '../types/article';
import { UseMutationOptions, UseQueryOptions } from '../types/react-query';

export const useQueryArticle = ({
  query,
  options,
}: {
  query: { search?: string, take?: number, page?: number, startDate?: string, endDate?: string};
  options?: UseQueryOptions<ArticleResponse>;
}) =>
  useQuery(
    ['article', query.take, query.page],
    () =>
      apiClient
        .get<unknown, { data: ArticleResponse }>(ApiArticle.articleList(query.search, query.take, query.page, query.startDate, query.endDate))
        .then((res) => res.data),
    options,
  );

export const useQueryArticleDetail = ({
  query,
  options,
}: {
  query: { articleId: string };
  options?: UseQueryOptions<ArticleDetailResponse>;
}) =>
  useQuery(
    ['articleDetail', query],
    () =>
      apiClient
        .get<ArticleDetailResponse>(ApiArticle.articleDetail(query.articleId))
        .then((res) => res.data),
    {
      // enabled: true,
      ...options,
    },
  );

export const useMutationDeleteArticle = (options?: UseMutationOptions) =>
  useMutation(
    (data: DeleteArticleRequest) =>
      apiClient
        .post<unknown, { data: string }>(`${ApiArticle.deleteArticle}`, data)
        .then((res) => res.data),
    options,
  );

export const useMutationAddArticleToProject = (options?: UseMutationOptions) =>
  useMutation(
    (data: AddArticleToProjectRequest) =>
      apiClient
        .post<unknown, { data: string }>(`${ApiArticle.addArticleToProject}`, data)
        .then((res) => res.data),
    options,
  );